import axios from 'axios';
import  {client_product}  from '../client';
import {
  GET_ALL_CATEGORIES,
  CREATE_CATEGORY,
  CREATE_SUBCATEGORY,
  DELETE_CATEGORY,
  UPDATE_CATEGORY,
} from '../categoryGQL';

const isDev = process.env.REACT_APP_ENV_SETTINGS === 'dev';

export const fetchCategoriesAndSubcategories = async () => {
  if (isDev) {
    const [catRes, subRes] = await Promise.all([
      axios.get('http://localhost:5000/categories'),
      axios.get('http://localhost:5000/subcategories')
    ]);
    return { categories: catRes.data, subcategories: subRes.data };
  } else {
    const { data } = await client_product.query({ query: GET_ALL_CATEGORIES });
    const categories = data.categories;
    const subcategories = categories.flatMap((cat: any) =>
      (cat.subcategories || []).map((sub: any) => ({
        ...sub,
        categoryId: cat.id
      }))
    );
    return { categories, subcategories };
  }
};

export const addCategory = async (
  data: { 
    name: string; 
    parentCategoryId?: string; 
    slug?: string; 
    icon?: string 
  }
) => {
  if (isDev) {
    const newCategory = { 
      id: Date.now().toString(), 
      name: data.name, 
      slug: data.slug || data.name.toLowerCase().replace(/\s+/g, '-'),
      parentCategoryId: data.parentCategoryId, 
      icon: data.icon 
    };
    const res = await axios.post('http://localhost:5000/categories', newCategory);
    return res.data;
  } else {
    const { data: response } = await client_product.mutate({
      mutation: CREATE_CATEGORY,
      variables: { 
        input: { 
          name: data.name, 
          slug: data.name.toLowerCase().replace(/\s+/g, '-'),
          parentCategoryId: data.parentCategoryId,
          icon: data.icon
        } 
      },
    });
    return response.createCategory;
  }
};

export const updateCategory = async (
  id: string, 
  data: { 
    name: string; 
    icon?: string 
  }
) => {
  if (isDev) {
    await axios.put(`http://localhost:5000/categories/${id}`, { 
      name: data.name, 
      icon: data.icon 
    });
  } else {
    await client_product.mutate({
      mutation: UPDATE_CATEGORY,
      variables: { 
        id, 
        input: { 
          name: data.name, 
          slug: data.name.toLowerCase().replace(/\s+/g, '-'),
          icon: data.icon 
        } 
      },
    });
  }
};

export const addSubcategory = async (
  data: {
    name: string;
    parentCategoryId: string;
    icon?: string;
  }
) => {
  if (isDev) {
    const newSub = { 
      id: Date.now().toString(), 
      name: data.name, 
      slug: data.name.toLowerCase().replace(/\s+/g, '-'),
      parentCategoryId: data.parentCategoryId, 
      icon: data.icon 
    };
    const res = await axios.post('http://localhost:5000/categories', newSub);
    return res.data;
  } else {
    const { data: response } = await client_product.mutate({
      mutation: CREATE_SUBCATEGORY,
      variables: { 
        input: { 
          name: data.name, 
          slug: data.name.toLowerCase().replace(/\s+/g, '-'),
          parentCategoryId: data.parentCategoryId,
          icon: data.icon 
        } 
      },
    });
    return { ...response.createSubCategory, parentCategoryId: data.parentCategoryId };
  }
};

export const deleteCategory = async (id: string) => {
  if (isDev) {
    await axios.delete(`http://localhost:5000/categories/${id}`);
  } else {
    await client_product.mutate({ mutation: DELETE_CATEGORY, variables: { id } });
  }
};


